(function (angular) {
    'use strict';

    angular
        .module("repairforms.service.module")
        .service("TooltipService", TooltipService);

    TooltipService.$inject = [];

    function TooltipService() {

        return {
            setTooltipsBehaviour : setTooltipsBehaviour
        };

        function setTooltipsBehaviour(document) {
            $('[data-toggle="popover"],[data-original-title]').popover();
            $(document).on('click' , function (e) {
                $('[data-toggle="popover"],[data-original-title]').popover().each(function () {
                    if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                        $(this).popover('hide').data('bs.popover').inState.click = false;
                    }
                });
            });
        };
    }

})(angular);